<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-user" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="t-title">{{ enrollment.users.last_name }}, {{ enrollment.users.first_name }}</div>
            <div v-if="progress !== false && ! enrollment.completed_at">
                <b-progress type="is-primary" size="is-small" :value="(progress/courseComponents.length)*100" class="enroll-progress"/>
                <div class="is-size-7 has-text-grey">{{progress}} of {{courseComponents.length}} lessons completed ({{((progress/courseComponents.length)*100).toFixed(0)}}%)</div>
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat"><i class="fas fa-fw" :class="{'fa-check': enrollment.status === 'complete', 'fa-exclamation-triangle': enrollment.status === 'missing' | enrollment.status === 'progress'}"></i></span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <div class="data mt-1">
                    <data-row mini title="Started">{{enrollment.created_at | moment('MMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Completed">{{enrollment.completed_at | moment('MMM Do YYYY, h:mm:ss a')}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'EnrollmentTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            enrollment: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            course: {
                type: Object,
                required: false
            }
        },
        data: function() {
            return {};
        },
        computed: {
            courseComponents: function() {
                if (this.course) {
                    let components = [];
                    this.course.course_outline.forEach(outline => {
                        outline.sections.section_components.forEach(component => {
                            components.push(component);
                        });
                    });

                    return components;
                } else {
                    return false;
                }
            },
            progress: function() {
                if (this.course) {
                    return 1 + this.courseComponents.findIndex(component => {
                        return component.component_id === this.enrollment.last_component;
                    });
                } else {
                    return false;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .t-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.7rem;
        }

        .fa-exclamation-triangle {
            color: #e28c07;
        }

        .fa-check {
            color: green;
        }
    }
</style>
<style lang="scss">

    .enroll-progress {
        margin-top: 10px;
        margin-bottom: 0.2rem !important;

        .progress {
            height: 0.25rem !important;
        }
    }
</style>
